module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Text","file":"File","form":"Form","iframe":"Iframe","locale changer":"Locale changer"}}')
  delete Component.options._Ctor
}
